export default "__VITE_ASSET__79d99bdf__"